"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
var _wrapNativeSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var HttpError = /*#__PURE__*/function (_Error) {
  _inherits(HttpError, _Error);
  var _super = _createSuper(HttpError);
  function HttpError(message, statusCode, statusText) {
    var _this;
    _classCallCheck(this, HttpError);
    _this = _super.call(this, message);
    _this.message = message;
    _this.name = "HttpError";
    _this.statusCode = statusCode;
    _this.status = statusCode;
    _this.statusText = statusText;
    return _this;
  }
  _createClass(HttpError, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        name: this.name,
        statusCode: this.statusCode,
        status: this.status,
        statusText: this.statusText,
        message: this.message
      };
    }
  }], [{
    key: "create",
    value: function create(failure) {
      // start with generic values
      var status = 0;
      var statusText = "Error";
      var message = "Unknown error";
      if (failure) {
        if (typeof failure == "object") {
          if (failure instanceof Error) {
            message = failure.message;
          } else if (failure.error) {
            status = failure.error.status || 0;
            statusText = failure.error.statusText || "Error";
            if (failure.error.responseText) {
              message = failure.error.responseText;
            }
          }
        } else if (typeof failure == "string") {
          message = failure;
        }
      }
      return new HttpError(message, status, statusText);
    }
  }]);
  return HttpError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
exports.default = HttpError;